import React from 'react';
import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

import Config from "../../Config.jsx";
import Localization from "../../Localization.jsx"
import SubmissionDetailContent from "./SubmissionDetailContent.jsx"

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Icon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';

class CompareAnswerDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
    };
    autoBind(this);
  }

  handleClose() {
    this.close();
  }

  close() {
    this.setState({ open: false });
  }

  render() {
    let answerData = this.props.parent.state.currentAnswerData;
    let componentData = this.props.parent.state.currentComponentData;
    if (answerData == null || componentData == null) {
      return (<div/>);
    }

    let kind = parseInt(componentData.kind);
    let name = (componentData.name != null? componentData.name : "");
    let content = (componentData.content != null? componentData.content : "");

    if (name == "") {
      name = Config.GET_HOTSPOT_CONTENT_CONFIG(kind).title;
    }

    return (
      <Dialog
        open={this.state.open}
        fullWidth={true}
        maxWidth={'md'}
        onClose={this.handleClose}
        scroll='paper'
      >
        <DialogTitle>
          <Icon style={{fontSize: '36px', verticalAlign:'middle'}}>
            {Config.GET_HOTSPOT_CONTENT_CONFIG(kind).icon}
          </Icon>
          {" " + name}
        </DialogTitle>
        <DialogContent>
          {this.props.parent.state.compareAnswerList.map( (row, i) => {
            let targetAnswerData = null;
            let hotspot_list = row['hotspot_list'] || [];
            for (let i = 0; i < hotspot_list.length; i++) {
              let hotspot = hotspot_list[i];
              let answer_list = hotspot['answer_list'];
              for (let j = 0; j < answer_list.length; j++) {
                let answer = answer_list[j];
                if (answer['component_id'] == answerData['component_id']) {
                  targetAnswerData = answer;
                }
              }
            }

            return (
              <div key={row['submission_data']?.id || i}>
                <List>
                  <If condition={targetAnswerData != null}>
                    <Then>
                      <ListItem>
                        <ListItemIcon>
                          <Icon style={{fontSize:'36px'}}>face</Icon>
                        </ListItemIcon>
                        <ListItemText
                          primary={row['submission_data'] != null ? row['submission_data']['user_name'] : ""}
                          secondary={Localization.strings.SUBMITTED + " " + (row['submission_data'] != null ? row['submission_data']['submission_time'] : "")}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon/>
                        <SubmissionDetailContent root={this.props.root} parent={this}
                        answerData={targetAnswerData}
                        componentData={componentData}
                        />
                      </ListItem>
                    </Then>
                    <Else>
                      <ListItem>
                        <ListItemIcon>
                          <Icon style={{fontSize:'36px'}}>face</Icon>
                        </ListItemIcon>
                        <ListItemText
                          primary={row['submission_data'] != null ? row['submission_data']['user_name'] : ""}
                          secondary="has not answered"
                        />
                      </ListItem>
                    </Else>
                  </If>
                </List>
                <Divider/>
              </div>
            );
          })}
        </DialogContent>
        <DialogActions style={{padding:'16px 24px'}}>
          <Button onClick={this.handleClose}>
            {Localization.strings.CLOSE}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default CompareAnswerDialog;
